"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var PropTypes = require("prop-types");
var React = require("react");
var classNames = require("classnames");
var AffirmBanner = /** @class */ (function (_super) {
    tslib_1.__extends(AffirmBanner, _super);
    function AffirmBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            expanded: false,
        };
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    AffirmBanner.prototype.toggle = function () {
        this.setState({ expanded: !this.state.expanded });
    };
    AffirmBanner.prototype.renderShowDetails = function () {
        if (!this.props.months.length) {
            return React.createElement("br", null);
        }
        return (React.createElement("a", { className: "affirm-banner__toggle", onClick: this.toggle }, I18n.t('discovery.affirmBanner.learnMore')));
    };
    AffirmBanner.prototype.render = function () {
        var classes = classNames('affirm-banner', { 'affirm-banner--open': this.state.expanded });
        return (React.createElement("aside", { className: classes },
            React.createElement("div", { className: "affirm-banner__inner" },
                React.createElement("h1", { className: "affirm-banner__title" }, I18n.t('discovery.affirmBanner.title')),
                React.createElement("p", { className: "affirm-banner__description" },
                    I18n.t('discovery.affirmBanner.description'),
                    React.createElement("br", null),
                    this.renderShowDetails()),
                React.createElement("p", { className: "affirm-banner__fineprint" }, I18n.t('discovery.affirmBanner.fineprint', {
                    months1: this.props.months[0],
                    months2: this.props.months[1],
                    months3: this.props.months[2],
                })))));
    };
    return AffirmBanner;
}(React.Component));
AffirmBanner.propTypes = {
    months: PropTypes.array,
};
AffirmBanner.defaultProps = {
    months: [],
};
exports.default = AffirmBanner;
//# sourceMappingURL=affirm_banner.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/affirm_banner.js
// module id = vneA
// module chunks = 20 21